export default __webpack_public_path__ + "static/form-default-values-dont-6e5120cff79bb0f062741723841db133.png";